
import "./AllClients.css";
import React, { Dispatch } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../context";
import DeleteIcon from '@mui/icons-material/Delete';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import NoteAddRoundedIcon from '@mui/icons-material/NoteAddRounded';
import Pagination from "react-js-pagination";

type PropsTypes = {
    activePage: number,
    setActivePage: Dispatch<React.SetStateAction<number>>,
    showClients: any[],
    setShowClients: Dispatch<React.SetStateAction<any[]>>,
    showChunk: any[],
    setShowChunk: Dispatch<React.SetStateAction<any[]>>,
    setConcretClient: Dispatch<React.SetStateAction<any>>,
    setOpenDelete: Dispatch<React.SetStateAction<boolean>>,
    setOpenReason: Dispatch<React.SetStateAction<boolean>>,
    setOpenCansel: Dispatch<React.SetStateAction<boolean>>,
}

export const downloadFile = async (client: any) => {

    const phoneNumberArrCheck = () => {
        const phoneNumbersArr = client.phoneNumbers;
        let phoneNumberResult = "";
        if (phoneNumbersArr.length > 0) {
            for (let i = 0; i < phoneNumbersArr.length; i++) {
                phoneNumberResult += `${phoneNumbersArr[i].key} - ${phoneNumbersArr[i].value}`
            }
        }
        return phoneNumberResult;
    }

    const socialMediaArrCheck = () => {
        const socialMediaArr = client.additionalData.socialMediaList;
        let socialMediaResult = "";
        if (socialMediaArr.length > 0) {
            for (let i = 0; i < socialMediaArr.length; i++) {
                socialMediaResult += `${socialMediaArr[i].key} - ${socialMediaArr[i].value}\n`
            }
        }
        return socialMediaResult;
    }

    const websiteArrCheck = () => {
        const websiteArr = client.websites;
        let websiteResult = "";
        if (websiteArr.length > 0) {
            for (let i = 0; i < websiteArr.length; i++) {
                websiteResult += `Website - ${websiteArr[i]}\n`
            }
        }
        return websiteResult;
    }

    const emailArrCheck = () => {
        const emailArr = client.emails;
        let emailResult = "";
        if (emailArr.length > 0) {
            for (let i = 0; i < emailArr.length; i++) {
                emailResult += `Email - ${emailArr[i]}\n`
            }
        }
        return emailResult;
    }

    const findMortgageLogo = (): string => {
        if (client.businessData.businessType === 'Mortgage') {
            return `Equal Housing Logo - ${ client.businessData.mortgageLogo }`;
        }
        else return '';
    }

    const textContent = `
        \nClient Name -  ${ client.clientNameMain ? client.firstName + " " + client.lastName : client.businessData.companyName } 
        \n${ phoneNumberArrCheck() }   
        \n${ emailArrCheck() } 
        \n${ websiteArrCheck() }
        \nLicense - ${ client.businessData.licenseNumbers[0] }
        \n------------------------------------------------------------------------
        \nNoun - ${ client.businessData.noun?.toUpperCase() }
        \nBusiness Term - ${ client.businessData.termForBusiness.toUpperCase() }
        \n${ findMortgageLogo() }
        \n------------------------------------------------------------------------
        \nBrokerage Name - ${ client.businessData.brokerageName }
        \n${ socialMediaArrCheck() }
        \nLocation - ${ client.includeAddressOnBranding ? client.address + " " + "(Yes)" : client.address + " " + "(No)"}
        \nAccount Manager - ${ client.accountManagerName }
        \nAdditional Notes - ${ client.additionalData.additionalNotes }
    `;

    const blob = new Blob([textContent], { type: 'text/plain' });
    const anchor = document.createElement('a');
    anchor.download = `${ client.firstName + " " + client.lastName }.txt`;
    anchor.href = window.URL.createObjectURL(blob);
    anchor.target = '_blank';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
}

function AllClientsTable({ activePage, setActivePage, showClients, showChunk, setConcretClient, setOpenDelete, setOpenReason, setOpenCansel }: PropsTypes) {

    const { findRole } = useGlobalContext();
    const navigate = useNavigate();
    const handlePageChange = (pageNumber: number): void => {
        setActivePage(pageNumber);
    }

    const editClient = (id: number): void => {
        if (id) {
            navigate(`/edit-client`, { state: { id } });
        }
    }

    const goToClientInfo = (id: number): void => {
        navigate("/client-info", { state: id });
    }

    return (
        <div className = "allClients-container-block">
            <table className = "allClients-table">
                <thead>
                    <tr>
                        {
                            ( findRole("PX") === "ADMIN" || findRole("PX") === "MODERATOR" ) &&
                                <th>Status</th>
                        }
                        <th>Full Name</th>
                        <th className="all-clients-email-data">Email</th>
                        <th className="all-clients-phoneNumber-data">Phone Number</th>
                        <th className="all-clients-creation-date">Creation Date</th>
                        <th className="all-clients-creation-date">Reason</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                {
                    showChunk?.map((client: any) => <tr key = { client.id }>
                        {
                            ( findRole("PX") === "ADMIN" || findRole("PX") === "MODERATOR" ) &&
                            <td>
                                {
                                    <button
                                        className = "allClientStatus"
                                        onClick = {() => {
                                            setConcretClient(client);
                                            if (!client.active) setOpenReason(true);
                                            else setOpenCansel(true);
                                        }}
                                    >
                                        <input
                                            type = "checkbox"
                                            className = "checkbox"
                                            defaultChecked = { !client.active }
                                        />
                                        <label
                                            htmlFor = {`toggle-${ client.id }`}
                                            className = "activateBtnLabel"
                                        >
                                            <span className = "activateBtn"></span>
                                        </label>
                                    </button>
                                }
                            </td>
                        }
                        <td
                            className = "clientFullNameData"
                            style = {{
                                cursor: "pointer"
                            }}
                            onClick = { () => goToClientInfo(client.id) }
                        >
                            { client.clientNameMain ? (client.firstName + " " + client.lastName) : client.businessData.companyName }
                        </td>
                        <td className = "all-clients-email-data">{ client.emails[0] }</td>
                        <td className = "all-clients-phoneNumber-data">{ client.phoneNumbers[0]?.value }</td>
                        <td className = "all-clients-creation-date">{ new Date(client.creationDate).toLocaleDateString() }</td>
                        <td className="all-clients-creation-date">
                            { client.cancellationReason ? client.cancellationReason === 'Other' ? client.cancellationOtherText : client.cancellationReason : '-' }
                        </td>
                        <td>
                            {
                                findRole("PX") === "ADMIN" &&
                                    <button
                                        className = "allClientSVGdelete"
                                    >
                                        <DeleteIcon
                                            titleAccess = "Delete"
                                            onClick = {() => {
                                                setConcretClient(client);
                                                setOpenDelete(true);
                                            }}
                                        />
                                    </button>
                            }
                            {
                                ( findRole("PX") === "ADMIN" || findRole("PX") === "MODERATOR" ) &&
                                    <BorderColorRoundedIcon
                                        titleAccess = "Edit"
                                        className = "allCLientSVGEdit"
                                        onClick = { () => editClient(client.id) }
                                    />
                            }
                            <button
                                className = "allClientSVGdownload"
                                title = "Download as a Text File"
                            >
                                <NoteAddRoundedIcon
                                    onClick = { () => downloadFile(client) }
                                />
                            </button>
                        </td>
                    </tr>
                    )
                }
                </tbody>
            </table>
            <div className = "allClients-pages">
                <Pagination
                    activePage = { activePage }
                    activeLinkClass = "activeLogPageNumber"
                    linkClass = "logPageNumber"
                    itemsCountPerPage = { 20 }
                    totalItemsCount = { showClients.length }
                    pageRangeDisplayed = { 5 }
                    hideFirstLastPages = { true }
                    onChange = { handlePageChange }
                />
            </div>
        </div>
    )
}

export default AllClientsTable;
